<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-10 16:40:07
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-10 16:40:39
 * @FilePath: /chaoyongtuan/src/views/talentCRM/tagManagement/components/tableCell/tagInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <el-tag>{{ row.tag_name }}</el-tag>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>